import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ApiDeviceHistoryEntryResponseDto, ApiScenarioHistoryEntryResponseDto, DeviceHistoryEventType} from '@birco/rainmesh-api';
import {CardComponent} from '../../../../shared/components/card/card.component';
import {TranslatePipe} from '@ngx-translate/core';
import {TimePipe} from '../../../../shared/pipes/time.pipe';
import {LabelConverter} from '../../../../shared/converter/label.converter';
import {LocalizedDatePipe} from '../../../../shared/pipes/localized-date.pipe';
import {HistoryGroupViewModel} from '../../models/history-view-model.interface';

@Component({
  selector: 'app-history',
  imports: [
    CardComponent,
    TranslatePipe,
    TimePipe,
    LocalizedDatePipe
  ],
  templateUrl: './history.component.html',
  styleUrl: './history.component.scss'
})
export class HistoryComponent {
  @Input() history: HistoryGroupViewModel[] = [];
  @Input() canLoadMore = false;
  @Input() loading = false;
  @Output() loadMore = new EventEmitter<void>();

  readonly skeletonRows = Array.from({length: 6});

  onLoadMore() {
    if (!this.canLoadMore) {
      return
    }
    this.loadMore.emit();
  }

  getDate(date: string) {
    return new Date(date);
  }

  trackByGroupDate(_index: number, group: HistoryGroupViewModel): string {
    return group.date;
  }

  trackByItemEventId(_index: number, item: ApiDeviceHistoryEntryResponseDto): string {
    return item.eventId;
  }

  getLabel(event: ApiDeviceHistoryEntryResponseDto | ApiScenarioHistoryEntryResponseDto): string {
    if ('scenario' in event) {
      return LabelConverter.getScenarioHistoryEventTypeLabel(event.eventType);
    }

    return LabelConverter.getHistoryEventTypeLabel(event.eventType as DeviceHistoryEventType);
  }

  getLabelParams(event: ApiDeviceHistoryEntryResponseDto | ApiScenarioHistoryEntryResponseDto): Record<string, string> {
    if ('scenario' in event) {
      return {
        scenario: event.scenario?.displayName ?? '',
      };
    }

    return {};
  }

  isScenarioHistoryEntry(event: ApiDeviceHistoryEntryResponseDto | ApiScenarioHistoryEntryResponseDto): event is ApiScenarioHistoryEntryResponseDto {
    return 'scenario' in event;
  }

  protected readonly LabelConverter = LabelConverter;
}
